import type { FC } from "react";

import type { FixCode, FixOf } from "../model/Fix";
import { CoreBuildOrderFix } from "./CoreBuildOrderFix";
import { CounterItemsFix } from "./CounterItemsFix";
import { ResistItemsFix } from "./ResistItemsFix";
import { SoulsSourcesFix } from "./SoulsSourcesFix";

// Код совета → компонент. Тип — по union советов из контракта: новый код на бэкенде
// не соберётся, пока для него нет компонента.
export type FixRenderers = { [C in FixCode]: FC<{ fix: FixOf<C> }> };

export const fixRenderers: FixRenderers = {
  counter_items: CounterItemsFix,
  resist_items: ResistItemsFix,
  core_build_order: CoreBuildOrderFix,
  souls_sources: SoulsSourcesFix,
};
